export const ssoEndpoints = {
  dovetailLogin: "/sso/dovetailLogin",
  imiLogin: "/sso/imiLogin",
  eiLogin: "/sso/eiLogin",
  userLogin: "/sso/userLogin",
};